export default __webpack_public_path__ + "static/media/rolos.bb8bb3ed.png";